export var SEARCH_PROJECTS_REQUEST = "HOME.SEARCH_PROJECTS_REQUEST";
export var SEARCH_PROJECTS_SUCCESS = "HOME.SEARCH_PROJECTS_SUCCESS";
export var ADD_USER_PROFILES = "HOME.ADD_USER_PROFILES";
export var ADD_RANDOM_PROJECTS = "HOME.ADD_RANDOM_PROJECTS";
export var ADD_POPULAR_PROJECTS = "HOME.ADD_POPULAR_PROJECTS";
export var SET_POPULAR_PROJECTS_OFFSET = "HOME.SET_POPULAR_PROJECTS_OFFSET";
export var SET_RANDOM_PROJECTS_LOADING = "HOME.SET_RANDOM_PROJECTS_LOADING";
